import GamesRoute from './GamesRoute';

export default GamesRoute;
